<ion-content class="ion-padding">
  <div [formGroup]="myForm">
    <ion-item>
      <ion-select
        formControlName="hidrante_id"
        placeholder="Seleccione hidrante"
        [compareWith]="compareWith"
        (ionChange)="handleChange($event)">
        @for (hidrante of hidrantes; track hidrante) {
          <ion-select-option [value]="hidrante.id">{{
            hidrante.name
          }}</ion-select-option>
        }
      </ion-select>
    </ion-item>
  </div>
</ion-content>
